import Description from "../../components/common/Description";
import { GetHcsMessageDesc } from "../../components/common/json-data/GetHcsMessageDesc";
import Grid from "@mui/material/Grid";
import ApiTest from "../../components/common/ApiTest";
import React from "react";
import { getHcsMessage } from "../../components/common/constants";
import { styled, useTheme } from "@mui/material/styles";
import MiniDrawer from "../../components/navBar/Sidenav";
import { Box } from "@mui/material";
function GetHcsMessage() {
  return (
    <div style={{ display: "flex" }}>
      <MiniDrawer />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Description bodyDesc={GetHcsMessageDesc[0]} />
          </Grid>
          <Grid item xs={6}>
            <ApiTest apidata={getHcsMessage} />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default GetHcsMessage;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));
